import React, { memo, useState, useCallback, useMemo } from "react";
import { Popover } from "@mui/material";
import blueeye from "../../../assets/images/blueeye.svg";
import pink_deleteicon from "../../../assets/images/pink_delete-icon.svg";
import { ActionButtonItem } from "./styles/TableStyles";
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import { useNavigate } from "react-router-dom";
import CheckIcon from "@mui/icons-material/Check";
import { UpdateCustomerStatus } from "../../../services/admin/customer";
import { toast } from "react-hot-toast";
import AssignOrderDriverPopup from "../dispatches/AssignOrderDriverPopup";
import BroadcastPopup from "../dispatches/BroadcastPopup";

const ActionItems = ({
  id,
  open,
  anchorEl,
  handleClose,
  SelectedRow,
  TableType = "",
  modifiedBodyData = [],
  setModifiedBodyData = () => {},
}) => {
  const navigate = useNavigate();
  const { status } = SelectedRow || {};

  const [isLoading, setisLoading] = useState(false);

  const ViewEventHandler = () => {
    if (TableType === "customers") {
      navigate(`/admin/customer-details/${SelectedRow?.slug}`);
    } else if (TableType === "drivers") {
      navigate(`/admin/drivers/personal-details/${SelectedRow?.slug}`);
    } else if (
      TableType === "dispatches" ||
      TableType === "dispatches/myquotes"
    ) {
      navigate(`/admin/dispatche-details/${SelectedRow?.order_id}`);
    }
  };

  // =========== customer ==========

  // Memoize the UpdateCustomerStatus function

  const memoizedUpdateCustomerStatus = useMemo(() => UpdateCustomerStatus, []);
  const ChangeCutomerStatus = useCallback(
    async (custom_status) => {
      const res = await memoizedUpdateCustomerStatus(
        setisLoading,
        SelectedRow?.slug,
        custom_status,
        TableType
      );

      if (res.status === 200) {
        const rowIndex = modifiedBodyData.findIndex(
          (row) => row.slug === SelectedRow?.slug
        );

        if (rowIndex !== -1) {
          const updatedBodyData = [...modifiedBodyData];
          updatedBodyData[rowIndex].status =
            updatedBodyData[rowIndex].status === "active"
              ? "inactive"
              : "active";
          setModifiedBodyData(updatedBodyData);
        }
        toast.success(`${custom_status} successfully`);
        handleClose();
      }
    },
    [setisLoading, SelectedRow?.slug, modifiedBodyData, setModifiedBodyData]
  );

  // =========== End customer ==========

  // =========== Dispatches  ==========

  const [openDialog, setOpenDialog] = useState(false);
  const [broadcastopenDialog, setbroadcastOpenDialog] = useState(false);

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const OpenAssignDriverPopup = () => {
    setOpenDialog(true);
    handleClose();
  };
  // broadcast popup
  const BroadcasthandleCloseDialog = () => {
    setbroadcastOpenDialog(false);
  };
  const OpenBroadcastPopup = () => {
    setbroadcastOpenDialog(true);
    handleClose();
  };

  // =========== End dispatches ==========

  return (
    <>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        PaperProps={{
          sx: {
            width: "150px",
            padding: "10px",
            background: "#FFFFFF",
            border: "1px solid #D9D9D9",
            boxShadow: "0px 1px 1px #D9D9D9",
            borderRadius: "13px",
          },
        }}
      >
        <ActionButtonItem onClick={ViewEventHandler}>
          <img src={blueeye} alt="blueeye" />
          View
        </ActionButtonItem>

        {(TableType === "customers" || TableType === "drivers") && (
          <>
            {status === "active" && (
              <ActionButtonItem
                className="block__btn"
                onClick={() => ChangeCutomerStatus("inactive")}
                disabled={isLoading}
              >
                <NotInterestedIcon />
                Reject
              </ActionButtonItem>
            )}
            {status === "inactive" && (
              <ActionButtonItem
                className="approve__btn"
                onClick={() => ChangeCutomerStatus("active")}
                disabled={isLoading}
              >
                <CheckIcon />
                Approve
              </ActionButtonItem>
            )}
            {status === "pending" && (
              <>
                <ActionButtonItem
                  className="block__btn"
                  onClick={() => ChangeCutomerStatus("inactive")}
                  disabled={isLoading}
                >
                  <NotInterestedIcon />
                  Reject
                </ActionButtonItem>
                <ActionButtonItem
                  className="approve__btn"
                  onClick={() => ChangeCutomerStatus("active")}
                  disabled={isLoading}
                >
                  <CheckIcon />
                  Approve
                </ActionButtonItem>
              </>
            )}
          </>
        )}

        {TableType === "dispatches" && (
          <>
            <ActionButtonItem
              className="approve__btn"
              onClick={OpenAssignDriverPopup}
            >
              {/* <CheckIcon /> */}
              Assign Driver
            </ActionButtonItem>
            <ActionButtonItem
              className="broadcastjob__btn"
              onClick={OpenBroadcastPopup}
            >
              {/* <CheckIcon /> */}
              Broadcast Job
            </ActionButtonItem>
          </>
        )}

        {/* {TableType !== "customers" &&
          TableType !== "drivers" &&
          TableType !== "dispatches" && (
            <ActionButtonItem className="delete__btn">
              <img src={pink_deleteicon} alt="blueeye" />
              Delete
            </ActionButtonItem>
          )} */}
      </Popover>

      {TableType === "dispatches" && (
        <>
          <AssignOrderDriverPopup
            open={openDialog}
            handleClose={handleCloseDialog}
            SelectedRow={SelectedRow}
          />
          <BroadcastPopup
            open={broadcastopenDialog}
            handleClose={BroadcasthandleCloseDialog}
            SelectedRow={SelectedRow}
          />
        </>
      )}
    </>
  );
};

export default memo(ActionItems);
